import React, { useEffect, useState } from "react";
import { Table, Space, Modal, Tag } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import EditFields from "./EditFields";
import fire from "./../../../../fire";

export default function ApplyClaimTable() {
  const ref = fire.firestore().collection("Expenses");
  const [data, setData] = useState([]);
  const [docId, setDocId]: any = useState();
  const [edit, setEdit] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getData = () => {
    ref.orderBy("cereatedOn", "desc").onSnapshot((querySnapshot) => {
      const items: any = [];
      querySnapshot.forEach((doc) => {
        items.push(doc.data());
      });
      setData(items);
    });
  };

  const deleteDoc = (docx: any) => {
    ref
      .doc(docx.id)
      .delete()
      .catch((err) => {
        alert(err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const editBox = (record: any) => {
    setIsModalVisible(true);
    setDocId(record.id);
    setEdit(!edit);
  };

  const columns = [
    {
      title: "Claim Type",
      dataIndex: "claimType",
      key: "claimType",
    },
    {
      title: "Expense ID",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "From Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (tags: any[]) => (
        <>
          <Tag color="volcano">{tags}</Tag>
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: any) => (
        <Space size="middle">
          <a>
            {" "}
            <EditOutlined
              style={{ color: "#1890FF" }}
              onClick={() => {
                editBox(record);
              }}
            />
          </a>
          <button style={{ background: "none", border: "none" }}>
            {" "}
            <DeleteOutlined
              style={{ color: "red" }}
              onClick={() => {
                deleteDoc(record);
              }}
            />
          </button>
        </Space>
      ),
    },
  ];

  const handleCallback = (childData: boolean) => {
    setIsModalVisible(childData);
  };

  return (
    <div>
      <Table columns={columns} dataSource={data} />
      <Modal
        title="Add Expense Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
      >
        <EditFields id={docId} parentCallback={handleCallback} />
      </Modal>
    </div>
  );
}
